import styled from '@themes/theme'
import { CommonLimitStyle, NavBottomPadding, preventScrollStyle, UploadImgPreviewCommonStyle } from '@styles/base.style'
import { ProfileImgWrapStyle } from '@views/Popup/Chat/index.style'

export const commentLineHeight = '150%'
const replyCommentExtraX = '52px'
export const AdvComments = styled.div`
  position: relative;
  z-index: 1;
  .am-list-header {
    padding: 18px;
  }
  &:not(.pc) {
    padding-bottom: ${NavBottomPadding};
  }
  .pick-comments-profile-btn {
    margin-top: 8px;
  }
  .profile-img-wrap {
    ${ProfileImgWrapStyle};
    width: 30px;
    height: 30px;
    &.blocked { // 차단된 유저의 분석글, 삭제된 분석글의 프로필 스타일
      opacity: .3;
    }
  }
  .total-comments-btn {
    z-index: 0;
    float: left;
    width: auto;
    height: 44px;
    margin: 10px 10px 0;
    padding: 0 14px;
    color: ${props => props.theme.color.disableTxt2};
    font-size: ${props => props.theme.font.large};

    svg {
      width: 9px;
      margin-left: 4px;
      transform: rotate(-90deg) translate(2px, 2px);
      path {
        fill: ${props => props.theme.color.disableTxt2};
      }
    }
  }
  .pick-comments-list {
    height: auto;
    padding: 0 18px;
    ${preventScrollStyle};
    &.popup {
      height: calc(100vh - 45px);
      &.pc-list {
        height: 100%;
      }
    }
    &::before {
      content: '';
      display: block;
      clear: both;
    }
    &--item {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      padding: 6px 9px 14px;
      border-bottom: 1px solid ${props => props.theme.color.subColor};

      &:first-of-type {
        border-top: 1px solid ${props => props.theme.color.subColor};
      }
      &.deleted {
        padding: 18px 0;
        font-size: ${props => props.theme.font.large};
        color: ${props => props.theme.color.darkTxt};
      }
      &.reply-exist {
        border-bottom: none;
        &.deleted {
          padding: 18px 0;
          font-size: ${props => props.theme.font.large};
          color: ${props => props.theme.color.darkTxt};
        }
      }
      .pick-comments-profile-btn {
        .profile-img-wrap {
          width: 42px;
          height: 42px;
        }
      }
      .comments-box {
        flex: 1;
        display: flex;
        flex-flow: column;
        align-items: flex-start;
        padding-left: 12px;

        .nickname {
          width: 100%;
          text-align: left;
          line-height: 3.6rem;
          font-size: ${props => props.theme.font.large};
          color: ${props => props.theme.color.themeTxt};
          letter-spacing: -0.3px;

          .comment-writer-mark {
            display: inline-block;
            width: 42px;
            height: 16px;
            line-height: 16px;
            border-radius: 10px;
            border: 1px solid ${props => props.theme.color.darkTxt};
            color: ${props => props.theme.color.darkTxt};
            margin-left: 5px;
            font-size: 10px;
            text-align: center;
            transform: translateY(-1px);
          }

          .date {
            float: right;
            margin-left: 2px;
            color: ${props => props.theme.color.contentsBg};
            font-weight: ${props => props.theme.fontW.medium};
            letter-spacing: -0.5px;
          }

          .edit-btn {
            position: relative;
            float: right;
            width: 45px;
            height: 36px;
            color: ${props => props.theme.color.btn};
            font-weight: ${props => props.theme.fontW.medium};

            .line {
              position: absolute;
              top: 50%;
              right: 0;
              transform: translateY(-50%);
              width: 1px;
              height: 12px;
              background: ${props => props.theme.color.disableBg};
            }
          }
          &.blocked {
            color: ${props => props.theme.color.btn};
          }
        }
        
        .block-message {
          color: ${props => props.theme.color.disableBg};
          font-size: ${props => props.theme.font.large};
          font-weight: ${props => props.theme.fontW.regular};
        }

        .comments {
          margin-top: -3px;
          line-height: ${commentLineHeight};
          word-break: break-all;
          white-space: pre-wrap;
          text-align: left;

          &, * {
            font-size: ${props => props.theme.font.large};
            font-weight: ${props => props.theme.fontW.regular};
            color: ${props => props.theme.color.darkTxt};
          }

          &.short {
            ${CommonLimitStyle};
            line-height: 2.1rem;
            max-height: 10rem;
          }

          .link {
            display: block;
            color: ${props => props.theme.color.blue};
          }

          .nick-tag {
            color: ${props => props.theme.color.blue};
            margin-right: 6px;
          }
        }

        // 등록된 댓글에서의 첨부영역
        .upload-preview {
          ${UploadImgPreviewCommonStyle};
        }

        .comment-btn-wrap {
          width: 100%;
          text-align: left;
          .write-comments-area {
            width: calc(100% + 10px);
            transform: translateX(-10px);
          }
          .reply-btn {
            width: 74px;
            height: 45px;
            font-size: ${props => props.theme.font.large};
            color: ${props => props.theme.color.btn};
            margin-left: 4px;
          }
        }
      }

      .comment-extra-btn {
        width: 20px;
        height: 20px;
        border-radius: 0;

        img {
          width: 3px;
          height: auto;
          object-fit: cover;
        }
      }
      .rsme-embed { // sns링크보기 스타일 변경(프리미엄 분석가 댓글, 나도승부사 댓글, 나의활동 댓글)
        &:first-of-type {
          margin-top: 6px;
        }
        &.rsme-instagram-embed, &.rsme-tiktok-embed {
          max-width: calc(100vw - 88px);
          overflow: hidden;
        }
      }
      &.pc {
        .rsme-embed {
          width: 100% !important;
          iframe, .fb-post {
            width: 100% !important;
            min-width: 328px;
          }
        }
      }
    }

    .reply-comments {
      padding-left: 42px;
      margin-bottom: 0 !important;

      .profile {
        .profile-img-wrap {
          width: 24px;
          height: 24px;
        }
      }

      // 답글에서의 댓글 입력창
      .write-comments-area {
        width: calc(100% + ${replyCommentExtraX}) !important;
        transform: translateX(-${replyCommentExtraX}) !important;
        margin: 0;
      }
      .pick-comments-list--item {
        .rsme-instagram-embed, .rsme-tiktok-embed { // sns링크보기 스타일 변경(프리미엄 분석가 답글, 나도승부사 답글)
          max-width: calc(100vw - 120px);
          overflow: hidden;
        }
        &.pc {
          .rsme-embed {
            max-width: 290px;
          }
        }
      }
    }
  }
  // 댓글 입력창
  .write-comments-area {
    width: auto;
    height: auto;
    min-height: 45px;
    padding: 14px 14px 10px;
    background: ${props => props.theme.color.subColor};
    border-radius: 9px;
    &.before {
      z-index: 0;
      display: flex;
      align-items: center;
      padding: 0;
      border-radius: 24px;
      .txt {
        margin-left: 12px;
        color: ${props => props.theme.color.disableBg};
        font-size: ${props => props.theme.font.large};
        font-weight: ${props => props.theme.fontW.regular};
      }
    }
    // 수정하기 댓글 입력창
    &.edit-comments {
      margin: 18px;
    }
    // 프리미엄 분석가 댓글창으로 이동하는 버튼
    &.no-bg {
      width: 100%;
      height: 60px;
      margin: 0;
      padding: 0 27px;
      background: none;
    }
  }
  .underline {
    opacity: .5;
    display: block;
    width: 100%;
    height: 1px;
    margin: 4px 0 30px;
    background: ${props => props.theme.color.subColor};
  }
  &.pick-comment-popup {
    height: 100%;
    padding-bottom: 0;
    background: ${props => props.theme.color.mainColor};
    &.pc {         
      height: 100%;
    }
    .am-list-body {
      padding: 0 18px;
      background: ${props => props.theme.color.mainColor};
    }
    .pick-comments-list {
      height: 100%;
      padding: 0;
      overflow-x: hidden !important;
      .list-view-section-body {
        margin-bottom: 100px;
      }
      &--item {
        padding: 6px 0 14px;
        background: ${props => props.theme.color.mainColor};
        .date {
          margin-right: 7px;
        }
      }
    }
  }
  &.sport-talk-editor {
    padding: 18px;
    background: ${props => props.theme.color.mainColor};
    .sport-talk-tit {
      &-wrap {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin: 0 0 12px 8px;
        .sport-talk-refresh-btn {
          .write-btn {
            width: 20px;
            height: 20px;
            position: relative;
            transform: translateY(-1px);
            &::before {
              content: '';
              display: block;
              position: absolute;
              top: 50%;
              left: 50%;
              width: inherit;
              height: inherit;
              transform: translate(-50%, -50%);
              background: ${props => props.theme.color.disableTxt};
              border-radius: 50%;
              opacity: 0.35;
            }
            .btn-ico {
              height: 100%;
              .page-reset-ico {
                width: 10px;
                transform: translateX(-.5px);
                path {
                  fill: ${props => props.theme.color.darkTxt};
                }
              }
            }
          }
        }
      }
      &-txt {
        margin-right: 6px;
        color: ${props => props.theme.color.themeTxt};
        font-size: ${props => props.theme.font.title};
        font-weight: ${props => props.theme.fontW.bold};
      }
    }
    .detail-bet-refresh-btn {
      position: static !important;
    }
    .ant-input {
      min-height: 75px !important;
      height: 75px !important;
      max-height: 75px !important;
      margin-top: 7px;
    }
  }
`
